<template>
  <div>
    <input type="checkbox" v-model="selected" @change="emitSelection" />
  </div>
</template>
<script>
import eventBus from "../../eventbus";

export default {
  data: function() {
    return {
      selected: false
    };
  },
  methods: {
    emitSelection: function() {
      eventBus.$emit(this.selected ? "select-all" : "deselect-all");
    }
  },
  created: function() {
    eventBus.$on(
      "deselected",
      function(row) {
        this.selected = false;
      }.bind(this)
    );

    eventBus.$on(
      "all-selected",
      function(row) {
        this.selected = true;
      }.bind(this)
    );
  }
};
</script>
